import ProcessConfig from './ProcessConfig';

export default class ProcessConfigPersonnelType extends ProcessConfig {
    // El tipo se puede elegir en convocatorias y provisiones.
    appliesToProcesses: boolean;
    // El tipo se puede elegir en los contratos de sustitución de las bolsas.
    appliesToContracts: boolean;

    constructor(data: any) {
        super(data);
        // Los títulos de los predeterminados ("Funcionario/Laboral") superan los 5 caracteres de los grupos.
        this.maxLength = 50;
        this.appliesToProcesses = data.appliesToProcesses !== undefined ? data.appliesToProcesses : true;
        this.appliesToContracts = data.appliesToContracts !== undefined ? data.appliesToContracts : true;
    }

    // El servidor exige al menos un ámbito de aplicación.
    public get hasAnyScope(): boolean {
        return this.appliesToProcesses || this.appliesToContracts;
    }

    // Los flags se envían siempre (alta, edición y cambio de visibilidad): el servidor no los asume.
    public toServer() {
        return {
            id: this.id,
            title: this.title,
            active: this.active,
            appliesToProcesses: this.appliesToProcesses,
            appliesToContracts: this.appliesToContracts
        };
    }
}
